import { apiGet, apiPut } from "./http";
import type { AgreementDocumentModel, AgreementDocType } from "../pages/admin/utils/defaultAgreementDocuments";

export interface AgreementDocumentDto {
  id: string;
  title: string;
  type: AgreementDocType;
  content: string;
  requiresign?: boolean;
  requireSign: boolean;
  version: string;
  updatedAt: string;
  isActive: boolean;
}

export function agreementModelsFromDtos(rows: AgreementDocumentDto[]): AgreementDocumentModel[] {
  return rows.map((r) => {
    const requireSign = r.requireSign ?? r.requiresign ?? false;
    return {
      id: r.id,
      title: r.title,
      type: r.type,
      content: r.content ?? "",
      requireSign,
      version: r.version,
      updatedAt: r.updatedAt,
      isActive: r.isActive !== false,
    };
  });
}

export async function fetchAgreementDocuments(tenantLegacyId: string): Promise<AgreementDocumentModel[]> {
  const res = await apiGet<{ documents: AgreementDocumentDto[] }>(
    `/api/tenants/${tenantLegacyId}/agreement-documents`,
  );
  return agreementModelsFromDtos(res.documents ?? []);
}

export async function putAgreementDocuments(
  tenantLegacyId: string,
  documents: AgreementDocumentModel[],
): Promise<AgreementDocumentModel[]> {
  const res = await apiPut<{ documents: AgreementDocumentDto[] }>(
    `/api/tenants/${tenantLegacyId}/agreement-documents`,
    documents,
  );
  if (res?.documents?.length) return agreementModelsFromDtos(res.documents);
  return documents;
}
